import { render, staticRenderFns } from "./SiteWideNotificationBar.vue?vue&type=template&id=68077f04"
import script from "./SiteWideNotificationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteWideNotificationBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports